import React from 'react';
import { Card, Form, Input, Select, Row, Col, DatePicker } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import CurvDown from '../svg/CurvDown';
import Calendar from '../svg/Calendar';

const { Option } = Select;

interface PositionInformationProps {
  form: FormInstance;
}

const PositionInformation: React.FC<PositionInformationProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];

  return (
    <div className="position-info-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .position-info-container .ant-form-item-label {
          min-height: 30px !important;
          margin-bottom: 8px !important;
          display: flex !important;
          align-items: flex-end !important;
        }
        @media (max-width: 1400px) {
          .position-info-container .ant-form-item-label {
            min-height: 58px !important;
          }
        }
        @media (max-width: 1200px) {
          .position-info-container .ant-form-item-label {
            min-height: 58px !important;
          }
        }
        @media (max-width: 768px) {
          .position-info-container .ant-form-item-label {
            min-height: unset !important;
            margin-bottom: 0px !important;
            display: block !important;
          }
        }
      `}} />
      <FormSection title="Position Information" columns={3}>
        <Form.Item
          label="Title of job you weren't selected for"
          name={['position_info', 'job_title']}
        >
          <Input placeholder="Enter job title" />
        </Form.Item>
        <Form.Item
          label="What was the date you weren't selected?"
          name={['position_info', 'date_not_selected']}
        >
          <DatePicker placeholder="Select date" format="DD-MM-YYYY" suffixIcon={<Calendar />} className="w-full" inputReadOnly />
        </Form.Item>

        <Form.Item
          label="Did you apply for the job?"
          name={['position_info', 'did_apply']}
        >
          <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
            {yesNoOptions.map(option => (
              <Option key={option} value={option}>{option}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Did you qualify for the job?"
          name={['position_info', 'did_qualify']}
        >
          <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
            {yesNoOptions.map(option => (
              <Option key={option} value={option}>{option}</Option>
            ))}
          </Select>
        </Form.Item>
      </FormSection>
    </div>
  );
};

export default PositionInformation;
